import * as angular from 'angular';
import {IController} from "angular";
import {CustomFieldModel} from "../../../site-preferences/models/custom-field.model";
import {SettingsService} from "../../../site-preferences/services/settings-service.service";
import * as _ from "lodash";

export class PackageDetailsSettingsPanelComponent implements IController {
  settings: any;
  onSettingsChange: Function;

  public packageCustomFields: CustomFieldModel[] = [];

  /* @ngInject */
  constructor(private $mdPanel, private settingsService: SettingsService) {

  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          columns: angular.copy(this.settings.columns),
          packageDynamicColumns: angular.copy(this.settings.packageDynamicColumns),
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: PackageDetailsSettingsCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: require('./template/panel-template.html').default,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason) => {
        panel.destroy();
      }
    };
    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig, parentScope) {
    parentScope.onSettingsChange({
      settings: settingsConfig
    })
  }

}

class PackageDetailsSettingsCtrl implements IController {
  private settingsConfig: any;
  public pageName: string;
  constructor(private mdPanelRef, private commonsConstants) {}

  $onInit() {
    this.settingsConfig = {
      columns: this.mdPanelRef.config.locals.data.columns,
      packageDynamicColumns: this.mdPanelRef.config.locals.data.packageDynamicColumns,
    };
    
  }

  onChangeColumns(columns) {
    this.settingsConfig.columns = columns;
  }

  onPackageColumnsChange(columns) {
    this.settingsConfig.packageDynamicColumns = columns;
  }

  onReset() {
    this.settingsConfig = {
      columns: this.commonsConstants.packageDetailsTableColumns,
    };
    this.submit()
  }

  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.settingsConfig, this.mdPanelRef.config.locals.data.parentScope);
    })
  }

  cancel() {
    this.mdPanelRef.close();
  }
}

angular
  .module('bringoz.admin.commons')
  .component('packageDetailsSettingsPanel', {
    bindings: {
      settings: '<',
      onSettingsChange: '&',
    },
    template: require('./package-details-settings-panel.html').default,
    controller: PackageDetailsSettingsPanelComponent
  });
